import React, { Component } from "react";

import THREE from "../utils/three";
//import isTouchDevice from "is-touch-device";

// const file = './test.dae'

class Render extends Component {
  camera = null;
  renderer = null;

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    let c = this.refs.container;
    this.camera.aspect = c.offsetWidth / c.offsetHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(c.offsetWidth, c.offsetHeight);
  };

  initRender = () => {
    var container;
    var scene, controls;

    //const isTouch = isTouchDevice()

    let settings = null;

    if (this.props.settings) settings = this.props.settings;
    else {
      settings = {
        back:
          "http://archive.vg.s3.amazonaws.com/New-Business-Assets/Programme/Render/Prog_Back_210x275mm.jpg",
        blockType: "render",
        depth: 15,
        front:
          "http://archive.vg.s3.amazonaws.com/New-Business-Assets/Programme/Render/Prog_Front_210x275mm.jpg",
        height: 350,
        pages:
          "http://archive.vg.s3.amazonaws.com/New-Business-Assets/Programme/Render/Prog_Pages_6mm.jpg",
        spine:
          "http://archive.vg.s3.amazonaws.com/New-Business-Assets/Programme/Render/Prog_Spine_6mm.jpg",
        width: 270,
      };
    }

    container = this.refs.container;

    let { front, back, spine, pages, width, height, depth } = settings;

    scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera(
      30,
      container.offsetWidth / container.offsetHeight,
      1,
      10000
    );
    this.camera.position.set(900, 0, 400);

    scene.add(new THREE.AmbientLight(0xcccccc));

    var light = new THREE.PointLight(0x333333);
    light.position.set(900, 0, -400);
    scene.add(light);

    // var light2 = new THREE.PointLight(0x333333);
    // light2.position.set(-900, 0, 400);
    // scene.add(light2);

    var light2 = new THREE.PointLight(0x333333);
    light2.position.set(0, -500, 0);
    scene.add(light2);

    // var loader = new THREE.TextureLoader();
    THREE.ImageUtils.crossOrigin = "";

    function addSide(url) {
      var options = {
        map: THREE.ImageUtils.loadTexture(url),
        shininess: 20,
        bumpScale: 0.85,
      };
      /*if(img === 'bottom'){
				options.specular = 0x222222;
				options.specularMap = THREE.ImageUtils.loadTexture('tiny/' + img + '_spec.jpg');
			}*/
      var material = new THREE.MeshPhongMaterial(options);
      return material;
    }

    var frontFace = addSide(front);
    var backFace = addSide(back);
    var frontSpineFace = addSide(spine);
    var backSpineFace = addSide(pages);

    var group = new THREE.Object3D();

    var box = new THREE.Mesh(
      new THREE.BoxBufferGeometry(depth, height, width),
      [
        frontFace,
        backFace,
        backSpineFace,
        backSpineFace,
        frontSpineFace,
        backSpineFace,
      ]
    );
    box.position.set(0, 0, 0);
    box.castShadow = true;

    group.add(box);

    scene.add(group);

    //var groundMaterial = new THREE.MeshLambertMaterial({color:0xFF0000} );
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
    });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(container.offsetWidth, container.offsetHeight);
    container.appendChild(this.renderer.domElement);
    this.renderer.gammaInput = true;
    this.renderer.gammaOutput = true;
    this.renderer.shadowMap.enabled = true;

    //if(!isTouch) {
    controls = new THREE.OrbitControls(this.camera, this.renderer.domElement);
    controls.enableZoom = false;
    controls.autoRotate = true;
    controls.minPolarAngle = Math.PI / 3;
    controls.maxPolarAngle = Math.PI / 1.5;
    /*controls.minAzimuthAngle = Math.PI/6;
			controls.maxAzimuthAngle = Math.PI/1.2;*/
    //}

    let _this = this;

    function animate() {
      requestAnimationFrame(animate);
      render();
      //stats.update();
    }

    function render() {
      /*var delta = clock.getDelta();
			if ( elf !== undefined ) {
				elf.rotation.z += delta * 0.5;
			}*/

      controls.update();

      //console.log(camera.position.z)

      _this.renderer.render(scene, _this.camera);
    }

    animate();
  };

  componentDidMount() {
    this.initRender();
    window.addEventListener("resize", this.handleResize);

    this.handleResize();
  }

  render() {
    return <div className="Render" ref="container" />;
  }
}

export default Render;



// WEBPACK FOOTER //
// ./src/js/components/Render.js